import React, { useState, useEffect } from "react"
import "./ScrollProgressBar.css"

export function ScrollProgressBar() {
	const [scrollProgress, setScrollProgress] = useState(0)

	useEffect(() => {
		const handleScroll = () => {
			const totalHeight = document.documentElement.scrollHeight - window.innerHeight
			if (totalHeight > 0) {
				const currentProgress = (window.pageYOffset / totalHeight) * 100
				setScrollProgress(Math.min(100, Math.max(0, currentProgress)))
			}
		}

		window.addEventListener("scroll", handleScroll, { passive: true })
		return () => window.removeEventListener("scroll", handleScroll)
	}, [])

	return (
		<div className="scroll-progress-container" aria-hidden="true">
			<div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }} />
		</div>
	)
}
